import { useCallback, useState } from 'react';

const useFetchData = config => {
  const { fetchFunc } = config;
  const [loading, setLoading] = useState(false);
  const [silentLoading, setSilentLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);

  const fetchData = useCallback(async () => {
    if (!loading) {
      try {
        setLoading(true);
        setError(false);
        const response = await fetchFunc();
        setData(response.data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    }
  }, [loading, fetchFunc]);

  const silentFetchData = useCallback(async () => {
    if (!silentLoading) {
      try {
        setSilentLoading(true);
        setError(false);
        const response = await fetchFunc();
        setData(response.data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setSilentLoading(false);
      }
    }
  }, [fetchFunc, silentLoading]);

  return {
    loading,
    error,
    data,
    silentFetchData,
    fetchData
  };
};

export default useFetchData;
